import urlAliasController from './url-alias';
import urlPatternController from './url-pattern';
import infoController from './info';
import coreController from './core';
import searchController from './search';

export default {
  'url-alias': urlAliasController,
  'url-pattern': urlPatternController,
  info: infoController,
  core: coreController,
  search: searchController,
};
